let workerInstance = null;
let runSeq = 0;
/** @type {{ signal: Int32Array, data: Uint8Array, length: Int32Array } | null} */
let stdinSab = null;

function attachWorkerSabListener(worker) {
  if (worker.__diobuchSabListener) return;
  worker.__diobuchSabListener = true;
  worker.addEventListener('message', (e) => {
    const msg = e.data || {};
    if (msg.type === 'stdin_sab_ready') {
      stdinSab = {
        signal: new Int32Array(msg.signalBuf),
        data: new Uint8Array(msg.dataBuf),
        length: new Int32Array(msg.lengthBuf),
      };
    }
    if (msg.type === 'stdin_sab_unavailable') {
      stdinSab = null;
    }
  });
}

function getWorker() {
  if (workerInstance) return workerInstance;
  workerInstance = new Worker(new URL('../workers/pyodideWorker.js', import.meta.url));
  attachWorkerSabListener(workerInstance);
  return workerInstance;
}

function resetWorker() {
  if (workerInstance) {
    workerInstance.terminate();
    workerInstance = null;
  }
  stdinSab = null;
}

/** Разблокировать worker после input() — через SharedArrayBuffer + Atomics.notify. */
export function deliverInteractiveStdinLine(line) {
  if (!stdinSab) return false;
  const bytes = new TextEncoder().encode(String(line ?? ''));
  const n = Math.min(bytes.length, stdinSab.data.length);
  stdinSab.data.fill(0);
  stdinSab.data.set(bytes.subarray(0, n));
  Atomics.store(stdinSab.length, 0, n);
  Atomics.store(stdinSab.signal, 0, 1);
  Atomics.notify(stdinSab.signal, 0);
  return true;
}

export function isInteractiveStdinReady() {
  return stdinSab != null;
}

/**
 * @param {string} code - Python code to run
 * @param {string} stdin - Input for input() calls (lines separated by \n), used when interactiveStdin is false
 * @param {Object} files - Optional: { 'input.txt': 'content', ... } - files to create in virtual FS before run
 * @param {Object} options - Optional: { signal?: AbortSignal, interactiveStdin?: boolean, onStdoutChunk?: fn, onStdinRequest?: fn }
 */
export async function runPython(code, stdin = '', files = {}, options = {}) {
  const runId = ++runSeq;
  const worker = getWorker();
  const onStdoutChunk = typeof options?.onStdoutChunk === 'function' ? options.onStdoutChunk : null;
  const onStdinRequest = typeof options?.onStdinRequest === 'function' ? options.onStdinRequest : null;
  const interactiveStdin = !!options?.interactiveStdin;

  return await new Promise((resolve, reject) => {
    const onMessage = (e) => {
      const msg = e.data || {};

      if (msg.type === 'stdout' && msg.runId === runId) {
        if (onStdoutChunk) onStdoutChunk(msg.chunk || '');
        return;
      }

      if (msg.type === 'stdin_request' && msg.runId === runId) {
        if (onStdinRequest) onStdinRequest({ requestId: msg.requestId });
        return;
      }

      if (msg.type !== 'result' || msg.runId !== runId) return;

      worker.removeEventListener('message', onMessage);
      if (msg.success) resolve({ success: true, output: msg.output || '' });
      else resolve({ success: false, error: msg.error || 'Ошибка выполнения', output: msg.output || '' });
    };

    worker.addEventListener('message', onMessage);

    let aborted = false;
    const onAbort = () => {
      aborted = true;
      worker.removeEventListener('message', onMessage);
      resetWorker();
      reject(new DOMException('Aborted', 'AbortError'));
    };

    if (options?.signal) {
      if (options.signal.aborted) return onAbort();
      options.signal.addEventListener('abort', onAbort, { once: true });
    }

    try {
      worker.postMessage({
        type: 'run',
        runId,
        code,
        stdin,
        files,
        interactiveStdin,
      });
    } catch (err) {
      worker.removeEventListener('message', onMessage);
      if (!aborted) reject(err);
    }
  });
}
